var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1E88EE",
    rx: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.513 10.425a1.289 1.289 0 0 0-1.02-.837l-3.005-.46-1.39-2.737a1.255 1.255 0 0 0-2.242 0l-1.39 2.737-3.038.435a1.255 1.255 0 0 0-1.012.837 1.23 1.23 0 0 0 .318 1.289l2.226 2.143-.519 3.004a1.23 1.23 0 0 0 .502 1.222 1.247 1.247 0 0 0 1.314.1l2.72-1.422 2.72 1.422a1.256 1.256 0 0 0 1.816-1.33l-.519-2.996 2.193-2.126a1.248 1.248 0 0 0 .326-1.28Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5h14v14H5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLite);
export default __webpack_public_path__ + "static/media/lite.0eaf94e053debc0283829bd9d09f2c97.svg";
export { ForwardRef as ReactComponent };